import { SecondaryButton } from "@vega-core/components/Buttons/SecondaryButton";
import { CounterBadge } from "@vega-core/components/CounterBadge/CounterBadge";
import { m } from "@vega-core/paraglide/messages";

type Props = {
  activeFilterCount: number;
  onResetFilters: () => void;
  showCounterBadge?: boolean;
  disabled?: boolean;
};

export function ResetFiltersButton({
  activeFilterCount,
  onResetFilters,
  showCounterBadge = false,
  disabled = false,
}: Props) {
  return (
    <div className="hidden md:flex items-center gap-2 relative">
      <SecondaryButton
        className="underline"
        dataTestId="table-filters-reset-button"
        disabled={disabled}
        onClick={onResetFilters}
        size="small"
        variant="tertiary"
      >
        {m.btn_resetTableFilters()}
      </SecondaryButton>{" "}
      {showCounterBadge ? (
        <CounterBadge
          className="absolute top-0 right-0 scale-75 text-background/primary"
          count={activeFilterCount}
          variant="rounded"
        />
      ) : null}
    </div>
  );
}
